import React from 'react';
import PropTypes from 'prop-types';

function Title({ title }) {
  return <div className="title">{title}</div>;
}

Title.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Title;
